import React from 'react';
import { PropTypes } from 'prop-types';
import Tabs from './Tabs';
import PostListContainer from '../Views/StructureComponents/PostListContainer';
import Tab from './Tab';
import MamContainer from '../Views/Mam/MamContainer';
import VenuesContainer from '../Views/VenueComponents/VenuesContainer';
import UsersContainer from '../Views/UsersComponents/UsersContainer';
import SubscriptionsContainer from '../Views/SubscriptionsComponents/SubscriptionsWrapper';
import ProductsContainer from '../Views/ProductsComponents/ProductsContainer';
import CommentsContainer from '../Views/CommentsComponents/CommentsContainer';
import LogsContainer from '../Views/LogsComponents/LogsContainer';
import EmailsSection from '../Views/EmailsComponents/EmailsSection';
import ArtistContainer from '../Views/ArtistComponents/ArtistContainer';
import TicketContainer from '../Views/TicketComponents/TicketContainer';
import ProReservationsContainer from '../Views/ProReservationsComponents/ProReservationsContainer';
import EventContainer from '../Views/EventComponents/EventContainer';
import LoyaltyContainer from '../Views/LoyaltyComponents/LoyaltyContainer';
import RadioContainer from '../Views/RadioComponents/RadioContainer';
import { CMS_TABS } from '../../utils/cmsTabs';


/*
The content of each tab, keyed by the labels in utils/cmsTabs. Plain factories
taking positional arguments, not components: only Structure needs anything
passed in, and a destructured first argument would read as a props object.

Rendering from
that list rather than from a second hand-written sequence is what keeps the
tabs, their URLs and MainWrapper's URL-to-index lookup in the same order — they
had already drifted apart once, which sent /cms/tickets to Venues.
*/
const TAB_CONTENT = {
  Structure: (onCategoryChange, category) => <PostListContainer handleCategoryChange={onCategoryChange} postCategory={category} />,
  MAM: () => <MamContainer />,
  Users: () => <UsersContainer />,
  Loyalty: () => <LoyaltyContainer />,
  Subscriptions: () => <SubscriptionsContainer />,
  Products: () => <ProductsContainer />,
  Comments: () => <CommentsContainer />,
  Logs: () => <LogsContainer />,
  Emails: () => <EmailsSection />,
  Events: () => <EventContainer />,
  'Artist sets': () => <ArtistContainer />,
  Venues: () => <VenuesContainer />,
  Tickets: () => <TicketContainer />,
  PRO: () => <ProReservationsContainer />,
  // Only in CMS_TABS when APP_NAME is 'ps' (see utils/cmsTabs).
  Radio: () => <RadioContainer />,
};

const MainTabsContainer = ({
  activeIndex, handleCategoryChange, postCategory, isSelectingCategory,
}) => (
  <div className="mt-4">
    <Tabs isSelectingCategory={isSelectingCategory} activeIndex={activeIndex}>
      {CMS_TABS.map(({ label }) => (
        <Tab key={label} label={label}>
          {TAB_CONTENT[label](handleCategoryChange, postCategory)}
        </Tab>
      ))}
    </Tabs>
  </div>
);

MainTabsContainer.propTypes = {
  handleCategoryChange: PropTypes.func,
  isSelectingCategory: PropTypes.bool,
  postCategory: PropTypes.string,
  activeIndex: PropTypes.number,
};

MainTabsContainer.defaultProps = {
  handleCategoryChange: null,
  isSelectingCategory: false,
  postCategory: null,
  activeIndex: 0,
};

export default MainTabsContainer;
